import type { SVGProps } from 'react';
const DawnFlagPG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-PG_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-PG_svg__a)">
      <path fill="#262626" d="M0 0h22v16H0z" />
      <path fill="#E8283F" fillRule="evenodd" d="M0 0h22v16z" clipRule="evenodd" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m5.238 13.333-.74.221.216-.754-.217-.754.741.22.74-.22-.216.754.217.754zM5.238 6.933l-.74.221.216-.754-.217-.754.741.22.74-.22-.216.754.217.754zM2.619 9.6l-.74.22.216-.753-.217-.755.74.221.742-.22-.217.754.217.754zM7.334 9.067l-.741.22.217-.754-.217-.754.74.22.742-.22-.217.754.217.754z"
        clipRule="evenodd"
      />
      <path
        fill="#FFD84E"
        fillRule="evenodd"
        d="M14.82 7.412a.52.52 0 0 1-.227-.401v-.983c0-.145-.103-.228-.258-.175l-.596.202a.9.9 0 0 1-.515 0l-.596-.202c-.142-.049-.158-.149-.03-.227l1.397-.853a.35.35 0 0 0 .141-.402l-.198-.606c-.048-.145.016-.228.172-.175l.595.202a.344.344 0 0 0 .394-.144l.839-1.423c.075-.128.17-.127.222.031l.199.607a.95.95 0 0 1 0 .525l-.199.606c-.047.145.03.263.172.263h.966c.142 0 .318.101.394.23l.839 1.424c.075.128.014.256-.122.284l-1.336.272a.44.44 0 0 0-.31.315l-.267 1.36c-.028.146-.151.202-.278.124z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagPG;
